import React, { useEffect } from "react";
import { connect, useDispatch } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import LoadingBar from 'react-redux-loading-bar';
import { handleSetAuthedUser } from "./store/actionCreators/authedUser";

import Login from './views/login';
import Dashboard from './views/dashboard';

function Routes(props) {
	const dispatch = useDispatch()
	useEffect(() => {
        dispatch(handleSetAuthedUser())
    }, [dispatch]);

	if (!props.loadingBar || !Object.keys(props.loadingBar).length || props.loadingBar.default) {
        return <LoadingBar />
	} else {
		return (
			<>
			<LoadingBar />
			<Router>
				<Switch>
					{props.authedUser === null
						? (<>
							<Route path="/login">
								<Login />
							</Route>
							<Redirect to="/login" />
						</>) : (<>
							{/* <Redirect strict exact from="/dashboard/" to="/dashboard" /> */}
							<Route strict exact path="/dashboard/" render={() => <Redirect to="/dashboard" />} />
							<Route path="/dashboard">
								<Dashboard />
							</Route>
							{/* <Redirect from="/" exact to="/dashboard" /> */}
                            <Route exact path="/" render={() => <Redirect to="dashboard" />} />
							<Route exact path="/login" render={() => <Redirect to="dashboard" />} />
						</> )
					}
				</Switch>
			</Router>
			</>
		);
	}
}

function mapStateToProps ({ authedUser, loadingBar }) {
	return {
		authedUser, loadingBar
	}
}

export default connect(mapStateToProps)(Routes);
